import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DOCUMENT_ACTION_TOOLTIP } from '../../../../constants/tooltipConstant';
import ConfirmDialog from '../../utils/ConfirmDialog';
import CustomTooltip from '../../utils/CustomTooltip';
import Toast from '../../utils/Toast';
import { classes } from './utils';
import { globalClasses } from '../../utils/globalUtils';
import { FLOW_TOAST } from '../../../../constants/toastConstant';
import trash from '../../../../assets/allInvoice-assets/trash-2.svg';
import { deleteMultipleFlows } from '../../../../services/flowConfiguration';

const SelectOption = ({
  totalData,
  selectedRow,
  handleApiCompletion,
  allRowSelected,
  setSelectedRows,
  setIsLoading,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const askingMessageData = allRowSelected ? totalData : selectedRow;
  const askingMessage =
    askingMessageData?.length > 1
      ? `Are You Sure You Want to Delete This ${askingMessageData.length} Selected Flows ?`
      : 'Are You Sure You Want to Delete This Flow ?';

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setSelectedRows([]);
    setIsDialogOpen(false);
  };

  const handleConfirmAction = async () => {
    try {
      setIsLoading(true);
      const selectedRowIds = askingMessageData.map((s) => s);
      const res = await deleteMultipleFlows(selectedRowIds);
      if (res) {
        setSelectedRows([]);
        handleCloseDialog();
        handleApiCompletion();
      }
      setIsLoading(false);
      Toast({
        message: allRowSelected
          ? FLOW_TOAST.ALL_FLOW_DELETED
          : FLOW_TOAST.FLOW_DELETED,
        variant: 'success',
      });
    } catch (error) {
      setIsLoading(false);
      setSelectedRows([]);
      Toast({ message: FLOW_TOAST.FLOW_DELETED_ERROR, variant: 'error' });
      return error;
    }
  };

  return (
    <Box
      className={`${classes.selectOptionsMainBox} ${
        selectedRow.length > 0
          ? globalClasses.visibility
          : globalClasses.notVisibility
      }`}
    >
      <Box
        className={`${classes.selectedFlowBox} ${
          selectedRow.length > 0
            ? globalClasses.visibility
            : globalClasses.notVisibility
        }`}
      >
        <Typography className={classes.flowSelectedTypo}>
          {allRowSelected ? totalData.length : selectedRow.length} Flow Selected
        </Typography>
        <CustomTooltip title={DOCUMENT_ACTION_TOOLTIP.DELETE}>
          <Box
            component="img"
            src={trash}
            alt="trash"
            onClick={() => handleOpenDialog()}
            className={classes.actionIcons}
          />
        </CustomTooltip>
        {isDialogOpen ? (
          <ConfirmDialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            onConfirm={handleConfirmAction}
            askingMessage={askingMessage}
            isStatusCompleted={undefined}
          />
        ) : null}
      </Box>
    </Box>
  );
};

SelectOption.propTypes = {
  selectedRow: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  totalData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  handleApiCompletion: PropTypes.func.isRequired,
  setSelectedRows: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  allRowSelected: PropTypes.bool.isRequired,
};
export default SelectOption;
